import script from "./RecommendGoal.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendGoal.vue?vue&type=script&setup=true&lang=js"

import "./RecommendGoal.vue?vue&type=style&index=0&id=0ad81123&scoped=true&lang=css"
import "./RecommendGoal.vue?vue&type=style&index=1&id=0ad81123&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad81123"]])

export default __exports__